"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_BASE_FRAME_NAV_REGION_ATTRIBUTES = exports.APP_BASE_FRAME_NAV_ATTRIBUTE = exports.APP_BASE_FRAME_NAV_ACTIVE_ATTRIBUTE = void 0;
exports.markAppBaseNavRoute = markAppBaseNavRoute;
/** On the navigation entry of the current page and the entry above it. */
exports.APP_BASE_FRAME_NAV_ACTIVE_ATTRIBUTE = 'data-sl-nav-active';
/** On each navigation of the frame; `secondary` on the one in its foot. */
exports.APP_BASE_FRAME_NAV_ATTRIBUTE = 'data-sl-frame-nav';
/** Frame regions whose entries name a route; the page outlet is not one of them. */
exports.APP_BASE_FRAME_NAV_REGION_ATTRIBUTES = [
    exports.APP_BASE_FRAME_NAV_ATTRIBUTE,
    'data-sl-frame-side',
    'data-sl-frame-actions',
    'data-sl-frame-bar',
];
const NAV_REGIONS = exports.APP_BASE_FRAME_NAV_REGION_ATTRIBUTES.map(attribute => '[' + attribute + ']').join(', ');
/** Whether the entry of `itemPath` names the page at `currentPath` or a page below it. */
function appBaseNavRouteMatches(itemPath, currentPath) {
    if (itemPath === '/')
        return currentPath === '/';
    const prefix = itemPath.replace(/\/$/, '');
    return currentPath === prefix || currentPath.startsWith(`${prefix}/`);
}
/**
 * Marks the entries of the shown frame for `routePath` as the frame renders
 * them: the longest matching route is the current page, its entry and the one
 * above it are active, and the more button of the bar stands for an entry in
 * its panel. Every earlier mark is cleared; `null` clears only.
 */
function markAppBaseNavRoute(document, routePath) {
    const regions = Array.from(document.querySelectorAll(NAV_REGIONS));
    const within = (selector) => [
        ...new Set(regions.flatMap(region => Array.from(region.querySelectorAll(selector)))),
    ];
    for (const element of within('[aria-current]'))
        element.removeAttribute('aria-current');
    for (const element of within('[' + exports.APP_BASE_FRAME_NAV_ACTIVE_ATTRIBUTE + ']'))
        element.removeAttribute(exports.APP_BASE_FRAME_NAV_ACTIVE_ATTRIBUTE);
    if (routePath === null)
        return;
    const links = within('[data-sl-route]');
    const current = links
        .map(link => link.getAttribute('data-sl-route') ?? '')
        .filter(path => appBaseNavRouteMatches(path, routePath))
        .sort((a, b) => b.length - a.length)[0];
    if (current === undefined)
        return;
    for (const link of links) {
        if (link.getAttribute('data-sl-route') !== current)
            continue;
        link.setAttribute('aria-current', 'page');
        // Top bar entries carry the current page, not the active entry.
        const entry = link.closest('li');
        if (!entry || entry.closest('[data-sl-frame-actions]'))
            continue;
        entry.setAttribute(exports.APP_BASE_FRAME_NAV_ACTIVE_ATTRIBUTE, '');
        entry.parentElement
            ?.closest('li')
            ?.setAttribute(exports.APP_BASE_FRAME_NAV_ACTIVE_ATTRIBUTE, '');
        const more = link.closest('[data-sl-frame-more]');
        if (!more?.id)
            continue;
        const button = document.querySelector(`button[popovertarget="${more.id}"]`);
        button?.setAttribute('aria-current', 'true');
        button
            ?.closest('li')
            ?.setAttribute(exports.APP_BASE_FRAME_NAV_ACTIVE_ATTRIBUTE, '');
    }
}
